import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Sun, Eye, EyeOff, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email.trim(), password.trim());
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. कृपया Email और Password सही से डालें।');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface-alt flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-orange-400 flex items-center justify-center">
              <Sun className="w-7 h-7 text-white" />
            </div>
            <div className="text-left">
              <h1 className="font-heading text-2xl font-semibold text-text-main">ViratAstro</h1>
              <p className="text-xs text-primary tracking-widest font-medium">ADMIN PANEL</p>
            </div>
          </Link>
        </div>

        {/* Login Card */}
        <div className="glass-card p-8">
          <h2 className="font-heading text-2xl text-text-main text-center mb-2">
            Admin Login
          </h2>
          <p className="text-text-muted text-center text-sm mb-8">
            Sign in to manage your website
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm text-text-muted mb-2 font-medium">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@viratastro.cloud"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label className="block text-sm text-text-muted mb-2 font-medium">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-text-muted hover:text-primary"
                  data-testid="toggle-password-btn"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center" data-testid="login-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-gold w-full flex items-center justify-center gap-2"
              data-testid="login-submit-btn"
            >
              {loading ? (
                'Loading...'
              ) : (
                <>
                  <LogIn className="w-4 h-4" />
                  Login
                </>
              )}
            </button>
          </form>

          <div className="mt-4 text-center">
            <Link to="/forgot-password" className="text-gold/90 hover:text-gold text-sm font-medium" data-testid="forgot-password-link">
              पासवर्ड भूल गए? · Forgot Password?
            </Link>
          </div>

          <div className="mt-6 text-center">
            <Link to="/" className="text-primary text-sm hover:underline">
              ← Back to Website
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
